/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomVersionFileFormat {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    constructor() {
        this.setDiscriminator("AppSecopsSbomVersionFileFormat");
    }

    getFixupPrototypeFunction() { return AppSecopsSbomVersionFileFormat.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomVersionFileFormat>): AppSecopsSbomVersionFileFormat {
        let obj = Object.assign(new AppSecopsSbomVersionFileFormat(), model);
        AppSecopsSbomVersionFileFormat.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomVersionFileFormat>): AppSecopsSbomVersionFileFormat {
        if (!model) return null;
        return AppSecopsSbomVersionFileFormat.newInstance(<AppSecopsSbomVersionFileFormat> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomVersionFileFormat) {
        if (!obj) return;

        models.AppSecopsSbomVersionFileFormat.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomVersionFileFormat): boolean {
        switch (obj.__type)
        {
            case "AppSecopsSbomVersionFileFormat":
                Object.setPrototypeOf(obj, AppSecopsSbomVersionFileFormat.prototype);
                break;
            case "AppSecopsSbomVersionFileFormatForCycloneDX":
                Object.setPrototypeOf(obj, models.AppSecopsSbomVersionFileFormatForCycloneDX.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof AppSecopsSbomVersionFileFormat)[] {
        return [
            models.AppSecopsSbomVersionFileFormatForCycloneDX,
        ];
    }

    fixupFields() {
    }

}
